import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-grow-1 flex-column pb-2 w-100" }
const _hoisted_2 = {
  ref: "root",
  class: "d-flex flex-grow-1 position-relative w-100"
}
const _hoisted_3 = { class: "position-absolute" }
const _hoisted_4 = {
  class: "position-absolute pa-2",
  style: {"left":"50%","bottom":"0px","transform":"translate(-50%, 0%)"}
}
const _hoisted_5 = { class: "text-caption" }
const _hoisted_6 = { class: "d-flex justify-center pa-2" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("モデルを閲覧する")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("モデルの軸を合わせる")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OrthographicCamera = _resolveComponent("OrthographicCamera")!
  const _component_DirectionalLight = _resolveComponent("DirectionalLight")!
  const _component_StandardMaterial = _resolveComponent("StandardMaterial")!
  const _component_Mesh = _resolveComponent("Mesh")!
  const _component_Scene = _resolveComponent("Scene")!
  const _component_Renderer = _resolveComponent("Renderer")!
  const _component_TransformForm = _resolveComponent("TransformForm")!
  const _component_MetricsViewer = _resolveComponent("MetricsViewer")!
  const _component_world_axis = _resolveComponent("world-axis")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_btn_toggle = _resolveComponent("v-btn-toggle")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Renderer, {
        ref: "renderer",
        "orbit-ctrl": "",
        resize: false,
        antialias: true,
        onMousedown: _ctx.mouseDown,
        onMousemove: _ctx.mouseMove,
        onMouseup: _ctx.mouseUp
      }, {
        default: _withCtx(() => [
          _createVNode(_component_OrthographicCamera, {
            ref: "camera",
            left: _ctx.state.orthographic.left,
            right: _ctx.state.orthographic.right,
            bottom: _ctx.state.orthographic.bottom,
            top: _ctx.state.orthographic.top,
            zoom: 1,
            near: 0.1,
            far: 1000,
            position: { z: 500 }
          }, null, 8, ["left", "right", "bottom", "top", "near"]),
          _createVNode(_component_Scene, {
            ref: "scene",
            background: 0xffffff
          }, {
            default: _withCtx(() => [
              _createVNode(_component_DirectionalLight, {
                position: _ctx.state.light
              }, null, 8, ["position"]),
              _createVNode(_component_Mesh, { ref: "mesh" }, {
                default: _withCtx(() => [
                  _createVNode(_component_StandardMaterial, { color: "#ffffff" })
                ]),
                _: 1
              }, 512)
            ]),
            _: 1
          }, 512)
        ]),
        _: 1
      }, 8, ["onMousedown", "onMousemove", "onMouseup"]),
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createVNode(_component_TransformForm, {
          ref: "transformForm",
          rotation: _ctx.state.rotation,
          "onUpdate:rotation": _ctx.updateRotation
        }, null, 8, ["rotation", "onUpdate:rotation"]), [
          [_vShow, _ctx.state.mode === 'transform']
        ]),
        _withDirectives(_createVNode(_component_MetricsViewer, {
          metrics: _ctx.machine.context.metrics.metrics,
          onReset: _ctx.resetAnchor
        }, null, 8, ["metrics", "onReset"]), [
          [_vShow, _ctx.state.mode === 'metrics']
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.file?.name), 1)
      ]),
      _createVNode(_component_world_axis, {
        ref: "axis",
        onAlign: _ctx.alignAxis
      }, null, 8, ["onAlign"])
    ], 512),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_v_btn_toggle, {
        modelValue: _ctx.state.mode,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.mode) = $event)),
        mandatory: "",
        dense: "",
        dark: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_btn, { value: "default" }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }),
          _createVNode(_component_v_btn, { value: "transform" }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ]))
}